import React from "react";
import { MdClose } from "react-icons/md";

const DrawerHeader = ({
    title,
    subtitle,
    icon,
    onClose,
    rightAction,
    className = "",
}) => {
    // bg-white/95
    return (
        <div
            className={`sticky top-0 z-20 bg-gradient-to-r from-primary-color to-[#00A0FF] backdrop-blur-md border-b border-gray-100
                px-5 py-4 ${className}`}>
            <div className="flex items-center justify-between gap-3">
                
                {/* Left Content */}
                <div className="flex items-center gap-3 min-w-0">
                    
                    {/* Icon */}
                    <div
                        className="h-11 w-11 rounded-2xl bg-[#EEF6FF] flex items-center justify-center shrink-0">
                        <div className="text-[#0078BD] text-lg">
                            {icon}
                        </div>
                    </div>

                    {/* Title */}
                    <div className="min-w-0">
                        <h2 className="text-lg font-semibold text-white truncate">
                            {title}
                        </h2>

                        {subtitle ? (
                            <p className="text-sm text-white truncate">
                                {subtitle}
                            </p>
                        ) : null}
                    </div>
                </div>

                {/* Right Actions */}
                <div className="flex items-center gap-2 shrink-0">
                    
                    {rightAction}

                    <button
                        onClick={onClose}
                        className="text-white/95 h-10 w-10 rounded-xl hover:bg-primary-color/40 flex items-center justify-center transition-all duration-200">
                        <MdClose size={20} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DrawerHeader;